import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class SmartFeedColumnMinWidth extends BaseOption {
  static label = "Column Min Width";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
    props: {
      inputType: "number",
      append: "px",
      defaultEmptyValue: 300,
    },
  };

  static defaultValue = 300;

  static canShow(smartFeedType) {
    return smartFeedType === "grid";
  }
}
